<template>
  <main class="login-main">
    <div class="login-input-wrap dp-flex">
      <div class="custom-shape-divider-top-1634722941">
        <img :src="require('@/assets/img/login-rafiki.svg')" />
      </div>
      <p class="loginname">Welcome back! Log in and start your work!</p>
      <div class="login-form">
        <div class="input-box dp-flex">
          <input type="text" placeholder="User Name" id="adminId" ref="siteId" v-model="model.siteId" @keyup.enter="onSubmit" />
        </div>
        <button class="signIn" type="button" @click="onSubmit">LOG IN</button>
      </div>
    </div>
    <div class="modal-wrapper" v-if="modalActive">
      <div class="modal-wrap">
        <article class="page-contents-wrap">
          <div class="sub-title">
            <h3>비밀번호<template v-if="isOtp">/ OTP</template> 입력</h3>
          </div>
          <div class="page-content">
            <div class="input-box dp-flex">
              <input type="password" placeholder="Password" ref="sitePass" v-model="model.sitePass" @keyup.enter="optSubmit" />
              <input v-if="isOtp" type="text" placeholder="OTP" ref="otp" v-model="otp" @keyup.enter="optSubmit" />
            </div>
            <div class="status-change-btn-wrap">
              <button class="signIn" type="button" @click="optSubmit()">VERIFY</button>
              <button class="signIn close" type="button" @click="modalClose()">CLOSE</button>
            </div>
          </div>
        </article>
      </div>
    </div>
  </main>
</template>

<script>
import { setAuthData, getAuthToken } from "@/libs/auth-helper";
import { signIn } from "@/api/utils";
import {apiIsOtpLogin} from "@/api/otp";

export default {
  name: "Login",
  data() {
    return {
      model: {
        siteId: "",
        sitePass: "1234",
      },
      otp: "",
      isOtp: false,
      modalActive: false
    };
  },
  computed: {
    canSubmit() {
      // To-do : this.model.siteId가 event 형태로 제공 되는 부분 설정
      // winner input component 확인
      // return this.model.siteId && this.model.sitePass && this.model.opt
      return this.model.siteId;
    }
  },
  created() {
    this.isLoginPage;
  },
  methods: {
    goPage() {
      this.$router.replace({ path: "/company" });
    },
    getsiteId(value) {
      this.model.siteId = value;
    },
    async modalOtpOpen() {
      this.modalActive = true
      if (this.modalActive) {
        if (this.$refs.otp) {
          this.$refs.otp.focus();
        }else{
        }
      }
    },
    modalClose() {
      this.modalActive = false;
    },
    async optSubmit() {
      if (!this.canSubmit) {
        for (const child in this.model) {
          if (!this.model[child]) {
            alert(this.$t(`alert.login.${child}`));
            this.$refs[child].focus();
            break;
          }
        }
        return;
      }

      if (this.isOtp) {
        if (!this.otp) {
          alert("otp를 입력해주세요.");
          this.$refs.otp.focus();
          return;
        }
      }

      const param = {...this.model, otp: this.otp}

      const res = await signIn(param);
      const resData = res.data;
      const succ = res.resultCode;
      if (succ === "0") {
        setAuthData(resData);
        this.goPage();
      } else {
        console.log("Login Fail");
        alert("로그인 실패, 다시 시도해주세요.");
      }
    },
    async onSubmit() {
      try {
        const otpRes = await apiIsOtpLogin(this.model)
        if (otpRes.resultCode === '0') {
          if (otpRes.data.useOtp === 'Y') {
            this.isOtp = true
          }
        }
        await this.modalOtpOpen();
      } catch (err) {
        console.log(err);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    const token = getAuthToken();
    if (token) {
      next("/member");
    } else {
      next();
    }
  }
};
</script>

<style scoped>
.login-wraaper {
  width: 100%;
  height: 100%;
}
.login-main {
  background: #eee;
  font-size: 12px !important;
  min-height: 100vh;
  background: #3d8fe5;
}
.login-main:after {
  content: none;
}

.login-input-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-wrap {
  position: relative;
  margin-bottom: 50px;
}
/* top wave */
.custom-shape-divider-top-1634722941 {
  text-align: center;
}
.custom-shape-divider-top-1634722941 img {
  width: 375px;
}
.loginname {
  color: #18698b;
  font-style: italic;
  font-size: 14px;
  margin: -40px 0 70px;
  font-weight: bold;
}
/* 로그인 */
.loginBody {
  height: 100vh;
  min-width: 0;
}
.loginBody span,
.loginBody div,
.loginBody input,
.loginBody button {
  font-family: "notoSans";
}
.login-main {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
}

.login-input-wrap {
  width: 655px;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  box-shadow: 9px 12px 19px -7px #646464c2;
  overflow: hidden;
  padding: 20px 0 80px;
  margin: 20px;
}
.word-wrap,
.login-input-wrap {
  position: relative;
  z-index: 2;
}
.login-form {
  width: 300px;
  text-align: center;
}
.input-box {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  box-sizing: border-box;
  padding-bottom: 3px;
}
.input-box::before {
  content: "";
  display: block;
  width: 2px;
  height: 10px;
  background: #2fa7d9;
  position: absolute;
  bottom: 12px;
}
.input-box img {
  width: 18px;
  margin-right: 20px;
}

.input-box input {
  width: 100%;
  height: 26px;
  background: transparent;
  font-size: 16px;
  letter-spacing: 1px;
  color: #303030;
  border: 0 !important;
  padding-left: 15px;
}
.input-box input[type="password"] {
  letter-spacing: 4px;
}
.input-box input::placeholder {
  letter-spacing: 0px;
  color: #bfbfbf;
}
.signIn {
  width: 230px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  background: #18698b;
  border: 2px solid #18698b;
  color: #fff;
  padding: 10px 0;
  box-sizing: border-box;
  cursor: pointer;
  margin-top: 50px;
}
.signIn:hover {
  background: #fff;
  color: #18698b;
}
.modal-wrapper {
  display: flex;
  font-size: 16px;
}
.signIn.close {
  background: red;
  border: 2px solid red;
}
.signIn.close:hover {
  background: #fff;
  color: red;
}
.sub-title {
  font-size: 1em;
  font-weight: 700;
  color: var(--main);
  height: 32px;
  position: relative;
  margin-bottom: 40px;
  border-bottom: 2px solid var(--main);
  padding-bottom: 20px;
}
.sub-title > h3 {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 1.4em;
  font-weight: 800;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
}
.modal-wrap {
  border-radius: 10px;
  min-width: unset;
  width: 24%;
  padding: 40px 2%;
  background: #fff;
  min-width: 320px;
}
.modal-wrap .input-box {
  width: 300px;
  margin-bottom: 40px;
}
.page-content {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.page-contents-wrap {
  margin-bottom: 0;
}
.modal-wrap .signIn {
  margin-top: 0;
  width: 100%;
  flex: 1 1 0;
}
.status-change-btn-wrap {
  width: 100%;
  gap: 5px;
}
.sub-title > h3::before {
  content: unset;
}
@media (max-width: 500px) {
   .login-input-wrap {padding: 20px;}
   .login-form {width: 100%;}
   .loginname {margin: 0 0 40px;}
   .signIn {margin-top: 40px;}
   .custom-shape-divider-top-1634722941 img {width: 100%;}
   .modal-wrap {width: calc(100% - 70px);padding: 15px;}
   .modal-wrap .input-box {display: block;width: 100%;}
   .modal-wrap .input-box input {position: relative;border-bottom: 2px solid #f0f0f0 !important;width: calc(100% - 25px);height: 30px;margin-bottom: 15px;}
   .modal-wrap .input-box::before {content: none;}
   .page-contents-wrap {padding: 15px;}
   .modal-wrap .input-box {border-bottom: 0;}
}
</style>
